// Story 7.7 — query hook for GET /api/v1/admin/feed/editorial?limit=20
// (the cockpit's recent-editorial history panel).

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { attachRequestIdToScope } from "../../lib/api-client";
import { ADMIN_EDITORIAL_QUERY_KEY } from "./useCreateEditorialPost";

export interface EditorialListItem {
  id: string;
  title: string;
  body_excerpt: string;
  published_at: string;
  status: string;
  moderation_state: string;
  admin_author_id: string | null;
}

export interface EditorialListResponse {
  items: EditorialListItem[];
}

async function fetchRecentEditorial(): Promise<EditorialListResponse> {
  const response = await fetch("/api/v1/admin/feed/editorial?limit=20", {
    credentials: "include",
  });
  attachRequestIdToScope(response);
  if (!response.ok) {
    throw new Error(`editorial list fetch failed (HTTP ${response.status})`);
  }
  return (await response.json()) as EditorialListResponse;
}

export function useRecentEditorial(): UseQueryResult<EditorialListResponse, Error> {
  return useQuery({
    queryKey: ADMIN_EDITORIAL_QUERY_KEY,
    queryFn: fetchRecentEditorial,
    staleTime: 15_000,
    retry: false,
  });
}
